module.exports = __webpack_public_path__ + "img/02n.9c3de5ca.svg";